<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test">集团简介设置</el-breadcrumb-item>
		</el-breadcrumb>


		<el-card style="margin-bottom: 50px;">
			<h4>集团荣誉：</h4>
			<el-table :data="rongyuList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column><!-- type="index" -->
				<el-table-column label="荣誉标题" prop="title"></el-table-column>
				<el-table-column label="荣誉简介" prop="introduction"></el-table-column>
				<el-table-column label="权重" prop="weights" width="70px"></el-table-column>
				<el-table-column label="荣誉封面图" prop="subsidiaryPicture" width="200px">
					<template slot-scope="scope">
						<img style="width: 150px;height: 150px;margin: 2px;"
							:src="$imgTitle + scope.row.coverPicture" />
					</template>
				</el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{ scope.row.createTime | dataFormat }}</template>
				</el-table-column>

				<el-table-column label="操作" width="250px">
					<template slot-scope="scope">
						<el-button type="primary" @click="gotoEditRongyu(scope.row.id)">编辑</el-button>
						<el-button type="danger" @click="delRongyu(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-button class="addBtn" type="success" @click="addRongYu">添加集团荣誉</el-button>
		</el-card>


		<el-card>
			<h4>集团子公司：</h4>
			<el-table :data="zigongsiList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column><!-- type="index" -->
				<el-table-column label="子公司标题" prop="name"></el-table-column>
				<el-table-column label="子公司简介" prop="introduction"></el-table-column>
				<el-table-column label="权重" prop="weights" width="70px"></el-table-column>
				<el-table-column label="子公司图片" prop="subsidiaryPicture">
					<template slot-scope="scope">
						<img style="width: 90px;height: 90px;margin: 2px;"
							v-for="(item, index) in scope.row.subsidiaryPicture.split(',')" :src="$imgTitle + item"
							:key="index" />
					</template>
				</el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{ scope.row.createTime | dataFormat }}</template>
				</el-table-column>

				<el-table-column label="操作" width="250px">
					<template slot-scope="scope">
						<el-button type="primary" @click="gotoEdit(scope.row.id)">编辑</el-button>
						<el-button type="danger" @click="delZigongsi(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-button class="addBtn" type="success" @click="addZigongsi">添加子公司</el-button>
		</el-card>

		<el-card style="margin-top: 50px;">
			<h4>集团发展历程：</h4>
			<el-table :data="lichengList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column>
				<el-table-column label="年份" prop="developmentTime"></el-table-column>
				<el-table-column label="内容" prop="introduction">
					<template slot-scope="scope">
						<div v-html="scope.row.content"></div>
					</template>
				</el-table-column>
				<el-table-column label="权重" prop="weights" width="70px"></el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{ scope.row.createTime | dataFormat }}</template>
				</el-table-column>
				<el-table-column label="操作" width="250px">
					<template slot-scope="scope">
						<el-button type="primary" @click="gotoEditFazhan(scope.row.id)">编辑</el-button>
						<el-button type="danger" @click="delFazhan(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页组件 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;">
			</el-pagination>
			<el-button class="addBtn" type="success" @click="addFazhan">添加发展历程</el-button>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			zigongsiList: [],
			lichengList: [],
			rongyuList: [],
			currentPage: 1,      // 当前页码
			pageSize: 10,        // 每页显示条数
			total: 0             // 总数据条数
		}
	},
	created() {
		this.getZigongsiList();
		this.getLichengList();
		this.getRongyuList();
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1; // 每页条数改变时，重置到第一页
			this.getLichengList();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getLichengList();
		},
		async getZigongsiList() {
			const res = await this.$http.post('/v1/official/manag/subsidiaryListInfo', JSON.stringify({}))
			console.log('zitongsires=' + JSON.stringify(res))
			if (res.data.code == 0) {
				this.zigongsiList = res.data.data.list;
			} else if (res.data.code == 102) {
				this.$router.push({
					path: '/login'
				})
			}
		},
		addZigongsi() {
			this.$router.push({
				path: '/addzigongsi'
			})
		},
		gotoEdit(id) {
			this.$router.push({
				path: '/editzigongsi',
				query: {
					id: id
				}
			})
		},
		gotoEditFazhan(id) {
			this.$router.push({
				path: '/editfazhan',
				query: {
					id: id
				}
			})
		},
		async getLichengList() {
			const res = await this.$http.post('/v1/official/manag/development/process/list', {
				request: {
                    pageNo: this.currentPage,
					pageSize: this.pageSize
				}
			})
			if (res.data.code == 0) {
				this.lichengList = res.data.data.list;
				this.total = res.data.data.totalNum || 0;
				console.log('total',res.data.data.totalNum);
				
			}
			console.log('fazhanlichengres=' + JSON.stringify(res))
			var fazhanlichengres = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"pageNo": 1,
						"totalNum": 8,
						"totalPage": 1,
						"list": [{
							"id": 5,
							"createTime": 1591928550000,
							"updateTime": 1591928553000,
							"developmentTime": "2020",
							"content": "<p>\r\n    <strong>2020年，九航润天医药连锁逆势发展；</strong>\r\n</p>\r\n<p>\r\n    九航旗下润天医药连锁发展壮大，搬迁新址，迈向新征程，至此，九航集团的办公场地面积再次扩大。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>\r\n<p>\r\n    <strong>2020年，慕茹姬品牌市场火爆；&nbsp;</strong>\r\n</p>\r\n<p>\r\n    九航旗下慕茹姬美妆品牌采用线上线下“组合拳”开拓市场，仅花一周时间品牌代理遍布重庆，三个月时间品牌代理遍布全国。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 5
						}, {
							"id": 6,
							"createTime": 1591928628000,
							"updateTime": 1591928630000,
							"developmentTime": "2019",
							"content": "<p>\r\n    <strong>2019年，创建慕茹姬医用美妆品牌；</strong>\r\n</p>\r\n<p>\r\n    慕茹姬美妆品牌依托九航集团的力量，开展线上线下相结合的销售模式，销售团队管理水平得到了进一步提升，为团队规模扩大打下了坚实的基础。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>\r\n<p>\r\n    <strong>2019年，九航与云南省农业科学院茶叶研究院种植基地签订合约；</strong>\r\n</p>\r\n<p>\r\n    宜关茶品牌将围绕做强茶叶品质、做大茶叶品牌目标，通过技术培训、技术咨询、技术服务、技术开发等方式，与云南省农业科学院茶叶研究种植基地开展合作，矢志为用户提供原产地生态茶叶。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 6
						}, {
							"id": 8,
							"createTime": 1591928781000,
							"updateTime": 1591928784000,
							"developmentTime": "2018",
							"content": "<p>\r\n    <strong>2018年九航集团实行股东合伙制</strong>\r\n</p>\r\n<p>\r\n    &nbsp;九航全面推行股东合伙管理制，形成集团化企业，成就九航人共同的事业。\r\n</p>",
							"weights": 8
						}, {
							"id": 9,
							"createTime": 1591928793000,
							"updateTime": 1591928795000,
							"developmentTime": "2017",
							"content": "<p>\r\n    <strong>2017年，创建宜关品牌</strong>\r\n</p>\r\n<p>\r\n    九航旗下云南宜关号茶业成立，在云南自建工厂，打造属于专注原产地的茶叶品牌——宜关。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 9
						}, {
							"id": 11,
							"createTime": 1591928891000,
							"updateTime": 1591928893000,
							"developmentTime": "2016",
							"content": "<p>\r\n    <strong>2016年，天兰茶业公司成立</strong>\r\n</p>\r\n<p>\r\n    天兰茶业以“公司+供应商+农户”运营模式和优质茶业资源，为茶叶生产提供了天然、绿色、健康、安全的高品质原料，有力地保障了产品的卓越品质。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>\r\n<p style=\"white-space: normal;\">\r\n    <strong>2016年，九航绩迅猛增长</strong>\r\n</p>\r\n<p style=\"white-space: normal;\">\r\n    子公司健驰医药成立，继续开拓瘦身、燕窝滋补等产品线，研发生产出品了“锐诺美”、“燕滋汇”等弛名品牌，为大健康、美容美妆奋力作为，产品与服务深受用户的好评。\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 11
						}, {
							"id": 3,
							"createTime": 1590655134000,
							"updateTime": 1590655138000,
							"developmentTime": "2015",
							"content": "<p>\r\n    <strong>2015年，九航积累了大量的优质客户资源</strong>\r\n</p>\r\n<p>\r\n    开始涉足网络营销服务，子公司森仕科技传媒成立，为用户提供精准营销传媒服务。\r\n</p>",
							"weights": 3
						}, {
							"id": 2,
							"createTime": 1590655134000,
							"updateTime": 1590655138000,
							"developmentTime": "2014",
							"content": "<p>\r\n    <strong>2014年，九航公司独立运营</strong>\r\n</p>\r\n<p>\r\n    加大技术研发投入与服务管理标准化，以技术和服务获得了口碑\r\n</p>",
							"weights": 2
						}, {
							"id": 1,
							"createTime": 1590655115000,
							"updateTime": 1590655115000,
							"developmentTime": "2013",
							"content": "<p>\r\n    <strong>2013年，九航公司在广州创立，</strong>\r\n</p>\r\n<p>\r\n    确立以电子行业为核心业务，以一流的技术为企业提供优质服务的经营理念。\r\n</p>",
							"weights": 1
						}]
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"date": "Tue, 30 Jun 2020 07:21:39 GMT",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/manag/development/process/list",
					"method": "post",
					"data": "{\"request\":{}}",
					"headers": {
						"Accept": "application/json, text/plain, */*",
						"Content-Type": "application/json;charset=utf-8",
						"Authorization": "1:76B60475C4EA29CD8A3A050C57EB3FD4A59BD0E0ED4708B4"
					},
					"baseURL": "http://xhm.jiuhuakang.com",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
		},
		addFazhan() {
			this.$router.push({
				path: '/addfazhan'
			})
		},
		async delFazhan(id) {
			console.log(typeof id)
			console.log(id)
			const confirmResult = await this.$confirm(
				'此操作将删除该年份历程, 是否继续?',
				'提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}
			).catch(err => err)
			if (confirmResult !== 'confirm') {
				return this.$message.info('已取消删除！')
			}
			var res = await this.$http.get('/v1/official/manag/deleteDevelopmentProcess', {
				params: {
					id: id
				}
			})
			console.log(JSON.stringify(res))
			if (res.data.code == 0) {
				this.$message.success('删除成功')
				this.getLichengList();
			} else {
				this.$message.error(res.data.message)
			}
		},
		async delZigongsi(id) { //删除集团子公司：/v1/official/manag/deleteSubsidiary  get请求 参数int id;
			console.log(id)
			const confirmResult = await this.$confirm(
				'此操作将删除该子公司, 是否继续?',
				'提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}
			).catch(err => err)
			if (confirmResult !== 'confirm') {
				return this.$message.info('已取消删除！')
			}
			var res = await this.$http.get('/v1/official/manag/deleteSubsidiary', {
				params: {
					id: id
				}
			})
			console.log(JSON.stringify(res))
			if (res.data.code == 0) {
				this.$message.success('删除成功')
				this.getZigongsiList();
			} else {
				this.$message.error(res.data.message)
			}
		},
		async getRongyuList() {
			/* 集团荣誉列表/v1/official/manag/honor/list  post请求  参数 int id  查列表可不传 id 传request{} */
			const res = await this.$http.post('/v1/official/manag/honor/list', {
				request: {}
			})

			console.log('集团荣誉列表res=' + JSON.stringify(res))
			var res123 = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"pageNo": 1,
						"totalNum": 4,
						"totalPage": 1,
						"list": [{
							"id": 4,
							"createTime": 1591946304000,
							"updateTime": 1591946306000,
							"coverPicture": "4.png",
							"introduction": "宜关宜关茶叶品牌喜获“中国著名品牌”殊荣\n2019年8月，宜关品牌入选为《中国著名品牌》,分体现了宜关茶的品牌竞争力、知名度、影响力得到市场的进一步认可。",
							"weights": 4,
							"ftext": null
						}, {
							"id": 3,
							"createTime": 1590655747000,
							"updateTime": 1590655747000,
							"coverPicture": "3.jpg",
							"introduction": "品牌锐不可挡，慕茹姬获主流媒体争相报道 \n慕茹姬专注美妆护肤领域，无论是从原材料的供应链、合作厂商的甄选，还是产品销售渠道等都建立了严格的标准，经过多年的努力，凭借超凡的品牌魅力荣获国内主流媒体称誉报道。",
							"weights": 3,
							"ftext": null
						}, {
							"id": 2,
							"createTime": 1590655747000,
							"updateTime": 1590655747000,
							"coverPicture": "1.png",
							"introduction": "宜关品牌强势登陆CCTV，亮相全国\n宜关能够亮相于央视，不仅是对品牌实力的有力见证，更表明了宜关对于生产优质原厂地生态茶的信心与决心。",
							"weights": 2,
							"ftext": null
						}, {
							"id": 1,
							"createTime": 1590636602000,
							"updateTime": 1590655747000,
							"coverPicture": "2.png",
							"introduction": "九航公司荣获“中国电子行业优秀服务商”\n广东九航喜获殊荣，来自于旗下的社交电商平台--九航云选。九航云选，作为一个综合的电商平台，旨在帮助会员惠享品质生活，同时实现社交价值，让生活更美更好。",
							"weights": 1,
							"ftext": null
						}]
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/manag/honor/list",
					"method": "post",
					"data": "{\"request\":{}}",
					"headers": {
						"Accept": "application/json, text/plain, */*",
						"Content-Type": "application/json;charset=utf-8",
						"Authorization": "1:E0EB93A027DA2523E1E49C4CE7EA20F7A0DE8CB06CCEE1D4"
					},
					"baseURL": "http://xhm.jiuhuakang.com",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
			if (res.data.code == 0) {
				this.rongyuList = res.data.data.list;
			}

		},
		gotoEditRongyu(id) {
			console.log(id)
			this.$router.push({
				path: '/editrongyu',
				query: {
					id: id
				}
			})
		},
		async delRongyu(id) {
			console.log(id)
			const confirmResult = await this.$confirm(
				'此操作将删除该集团荣誉, 是否继续?',
				'提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}
			).catch(err => err)
			if (confirmResult !== 'confirm') {
				return this.$message.info('已取消删除！')
			}
			/* 删除集团荣誉/v1/official/manag/deleteHonorById get请求 参数 int id */
			var res = await this.$http.get('/v1/official/manag/deleteHonorById', {
				params: {
					id: id
				}
			})
			console.log(JSON.stringify(res))
			if (res.data.code == 0) {
				this.$message.success('删除成功')
				this.getRongyuList();
			} else {
				this.$message.error(res.data.message)
			}
		},
		addRongYu() {
			this.$router.push({
				path: '/addrongyu'
			})
		}
	}
}
</script>

<style lang="less" scoped>
.addBtn {
	margin-top: 20px;
}
</style>
